import React from "react";

const DefaultImagesIcon = ({ fill }) => {
  return (
    <svg
      id="db32"
      xmlns="http://www.w3.org/2000/svg"
      width="21.504"
      height="18.398"
      viewBox="0 0 21.504 18.398"
    >
      <path
        id="Path_1263"
        data-name="Path 1263"
        d="M5.853,29.344c4.318-1.822,11.362-4.959,19.8-5.393v-.871a43.937,43.937,0,0,0-8.038,1.2,40.36,40.36,0,0,0-8.239-2.122q7.085-3.062,9.052-3.062c1.871,0,4.619,1.237,7.225,2.256v-6.28H5.853v7.408a46.392,46.392,0,0,1,10.342,2.192c-3.237.688-8.4,3.143-10.342,3.947ZM25.07,14.028h1.147a.288.288,0,0,1,.287.29v15.79a.288.288,0,0,1-.287.29H5.287A.288.288,0,0,1,5,30.108V14.318a.288.288,0,0,1,.287-.29h1.29V13.3a.288.288,0,0,1,.287-.29H8.011V12.29A.288.288,0,0,1,8.3,12h15.2a.288.288,0,0,1,.287.29v.724h1a.288.288,0,0,1,.287.29Zm-.745-.016v-.287H7.274v.287Zm-1.232-.958v-.287H8.789v.287Z"
        transform="translate(-5 -12)"
        fill={fill ? fill : "#707070"}
      />
    </svg>
  );
};

export default DefaultImagesIcon;
